import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, isMemoSame as _isMemoSame, withMemo as _withMemo } from "vue"

const _hoisted_1 = { class: "conv-panel" }
const _hoisted_2 = { class: "conv-head" }
const _hoisted_3 = { class: "conv-title" }
const _hoisted_4 = { style: {"background":"rgba(188,12,36,.08)","color":"var(--red)","padding":"2px 8px","border-radius":"20px","font-size":"11.5px","font-weight":"700"} }
const _hoisted_5 = { class: "filters" }
const _hoisted_6 = { class: "search-box" }
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "date-range" }
const _hoisted_11 = { class: "tbl-wrap" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { style: {"font-weight":"700","color":"var(--ink-40)"} }
const _hoisted_14 = { class: "contact-cell" }
const _hoisted_15 = ["onMouseenter"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "c-name" }
const _hoisted_18 = {
  key: 0,
  class: "c-phone"
}
const _hoisted_19 = {
  key: 1,
  class: "c-doc"
}
const _hoisted_20 = {
  key: 2,
  class: "c-doc"
}
const _hoisted_21 = {
  key: 0,
  class: "assignee-cell"
}
const _hoisted_22 = ["src", "alt", "onMouseenter"]
const _hoisted_23 = ["onMouseenter"]
const _hoisted_24 = { class: "a-name" }
const _hoisted_25 = {
  key: 1,
  style: {"color":"var(--ink-40)","font-size":"12px"}
}
const _hoisted_26 = { style: {"font-weight":"500","text-transform":"capitalize"} }
const _hoisted_27 = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_28 = {
  key: 1,
  style: {"color":"var(--ink-40)"}
}
const _hoisted_29 = { class: "label-chips" }
const _hoisted_30 = {
  key: 1,
  style: {"color":"var(--ink-40)","font-size":"12px"}
}
const _hoisted_31 = {
  key: 0,
  class: "fluxo-pill"
}
const _hoisted_32 = {
  key: 1,
  style: {"color":"var(--ink-40)","font-size":"12px"}
}
const _hoisted_33 = { style: {"display":"flex","gap":"4px","align-items":"center"} }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "pagination" }
const _hoisted_37 = { class: "pag-left" }
const _hoisted_38 = { class: "pag-info" }
const _hoisted_39 = { class: "pag-controls" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "pag-ellipsis"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["disabled"]

import { ref, computed, watch } from 'vue'
import type { Conversation, PopupData } from '@/types/dashboard'
import { avatarColor, initials, fmtChannel, fmtWait, convDuration, fluxoLabel, conversationProtocol } from '@/composables/useHelpers'
import { fmtPhone, fmtDoc } from '@/utils/contactsFormat'


export default /*@__PURE__*/_defineComponent({
  __name: 'ConversationsPanel',
  props: {
    conversations: {},
    loading: { type: Boolean },
    scopeReady: { type: Boolean },
    changedIds: {}
  },
  emits: ["showPopup", "hidePopup", "openChat", "openHistory"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit  = __emit

const query        = ref('')
const filterStatus = ref('')
const filterTeam   = ref('')
const filterLabel  = ref('')
const filterFluxo  = ref<number | ''>('')
const dateFrom     = ref('')
const dateTo       = ref('')
const currentPage  = ref(1)
const pageSize     = ref(10)

const teamOptions = computed(() =>
  [...new Set(props.conversations.map(c => c.team?.name || '').filter(Boolean))].sort()
)

const labelOptions = computed(() =>
  [...new Set(props.conversations.flatMap(c => c.labels))].filter(Boolean).sort()
)

const fluxoOptions = computed(() => {
  const ids = [...new Set(props.conversations
    .map(c => c.fluxo_id)
    .filter((id): id is number => id !== null)
  )].sort((a, b) => a - b)
  return ids.map(id => ({ id, name: fluxoLabel(id) }))
})

const filtered = computed(() => {
  const q       = query.value.toLowerCase()
  const tsFrom  = dateFrom.value ? new Date(dateFrom.value).getTime() / 1000 : null
  const tsTo    = dateTo.value   ? new Date(dateTo.value).getTime()   / 1000 + 86399 : null
  return props.conversations.filter(c => {
    if (q && !(
      c.contact.name.toLowerCase().includes(q) ||
      c.contact.phone.toLowerCase().includes(q) ||
      (c.assignee?.name || '').toLowerCase().includes(q) ||
      (c.team?.name    || '').toLowerCase().includes(q)
    )) return false
    if (filterStatus.value && c.status !== filterStatus.value) return false
    if (filterTeam.value   && (c.team?.name || '') !== filterTeam.value) return false
    if (filterLabel.value  && !c.labels.includes(filterLabel.value)) return false
    if (filterFluxo.value !== '' && c.fluxo_id !== filterFluxo.value) return false
    if (tsFrom && c.created_at < tsFrom) return false
    if (tsTo   && c.created_at > tsTo)   return false
    return true
  })
})

watch(filtered, () => { currentPage.value = 1 })

const totalPages = computed(() => Math.max(1, Math.ceil(filtered.value.length / pageSize.value)))
const pageStart  = computed(() => (currentPage.value - 1) * pageSize.value)
const pageEnd    = computed(() => Math.min(pageStart.value + pageSize.value, filtered.value.length))
const pageConvs  = computed(() => filtered.value.slice(pageStart.value, pageEnd.value))

const pageButtons = computed(() => {
  const total = totalPages.value
  const cur   = currentPage.value
  const WING  = 2
  const pages: (number | string)[] = []
  let prev: number | null = null
  for (let p = 1; p <= total; p++) {
    if (p === 1 || p === total || (p >= cur - WING && p <= cur + WING)) {
      if (prev !== null && p - prev > 1) pages.push('…')
      pages.push(p)
      prev = p
    }
  }
  return pages
})

function goPage(p: number) {
  currentPage.value = Math.max(1, Math.min(p, totalPages.value))
}
function clearDates() {
  dateFrom.value = ''
  dateTo.value   = ''
}
function statusLabel(s: string) {
  const map: Record<string, string> = { open: 'Aberta', resolved: 'Resolvida', pending: 'Pendente', snoozed: 'Adiada' }
  return map[s] || s
}
function durOf(c: Conversation) { return convDuration(c) }
function waitOf(c: Conversation) {
  return fmtWait(c.waiting_since)
}

function showContactPopup(c: Conversation, e: MouseEvent) {
  emit('showPopup', {
    name:    c.contact.name,
    role:    'Contato',
    phone:   c.contact.phone,
    channel: fmtChannel(c.channel),
    team:    c.team?.name || null,
    status:  c.status,
    labels:  c.labels,
  }, e.currentTarget as HTMLElement)
}
function showAssigneePopup(c: Conversation, e: MouseEvent) {
  if (!c.assignee) return
  emit('showPopup', {
    name:      c.assignee.name,
    role:      c.assignee.role,
    email:     c.assignee.email  || '',
    thumbnail: c.assignee.thumbnail || '',
    team:      c.team?.name || null,
    status:    c.assignee.availability || 'offline',
  }, e.currentTarget as HTMLElement)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "sec" }, "Todas as Conversas", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[16] || (_cache[16] = _createElementVNode("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
          ], -1)),
          _cache[17] || (_cache[17] = _createTextVNode(" Conversas ", -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(filtered.value.length), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[18] || (_cache[18] = _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("circle", {
                cx: "11",
                cy: "11",
                r: "8"
              }),
              _createElementVNode("line", {
                x1: "21",
                y1: "21",
                x2: "16.65",
                y2: "16.65"
              })
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
              class: "search-input",
              type: "search",
              placeholder: "Buscar contato, agente…"
            }, null, 512), [
              [_vModelText, query.value]
            ])
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterStatus).value = $event)),
            class: "flt"
          }, [...(_cache[19] || (_cache[19] = [
            _createElementVNode("option", { value: "" }, "Todos os status", -1),
            _createElementVNode("option", { value: "open" }, "Aberta", -1),
            _createElementVNode("option", { value: "resolved" }, "Resolvida", -1),
            _createElementVNode("option", { value: "pending" }, "Pendente", -1)
          ]))], 512), [
            [_vModelSelect, filterStatus.value]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterTeam).value = $event)),
            class: "flt"
          }, [
            _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, "Todos os times", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamOptions.value, (t) => {
              return (_openBlock(), _createElementBlock("option", {
                key: t,
                value: t
              }, _toDisplayString(t.charAt(0).toUpperCase() + t.slice(1)), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, filterTeam.value]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterLabel).value = $event)),
            class: "flt"
          }, [
            _cache[21] || (_cache[21] = _createElementVNode("option", { value: "" }, "Todas as etiquetas", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labelOptions.value, (l) => {
              return (_openBlock(), _createElementBlock("option", {
                key: l,
                value: l
              }, _toDisplayString(l.replace(/_/g, ' ')), 9, _hoisted_8))
            }), 128))
          ], 512), [
            [_vModelSelect, filterLabel.value]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filterFluxo).value = $event)),
            class: "flt"
          }, [
            _cache[22] || (_cache[22] = _createElementVNode("option", { value: "" }, "Todos os fluxos", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fluxoOptions.value, (f) => {
              return (_openBlock(), _createElementBlock("option", {
                key: f.id,
                value: f.id
              }, _toDisplayString(f.name), 9, _hoisted_9))
            }), 128))
          ], 512), [
            [_vModelSelect, filterFluxo.value]
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[23] || (_cache[23] = _createElementVNode("label", null, "De", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dateFrom).value = $event)),
              class: "flt-date",
              type: "date"
            }, null, 512), [
              [_vModelText, dateFrom.value]
            ]),
            _cache[24] || (_cache[24] = _createElementVNode("label", null, "até", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dateTo).value = $event)),
              class: "flt-date",
              type: "date"
            }, null, 512), [
              [_vModelText, dateTo.value]
            ]),
            _createElementVNode("button", {
              class: "btn-clear-date",
              title: "Limpar datas",
              onClick: clearDates
            }, "✕")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("table", null, [
          _cache[39] || (_cache[39] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "#"),
              _createElementVNode("th", null, "Contato"),
              _createElementVNode("th", null, "Agente"),
              _createElementVNode("th", null, "Time"),
              _createElementVNode("th", null, "Status"),
              _createElementVNode("th", null, "Duração"),
              _createElementVNode("th", null, "Aguardando"),
              _createElementVNode("th", null, "Etiquetas"),
              _createElementVNode("th", null, "Fluxo"),
              _createElementVNode("th", { style: {"width":"72px"} })
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (!props.scopeReady && props.conversations.length === 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(pageSize.value, (i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `skel-${i}`,
                    class: "skel-row"
                  }, [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "skel skel-sm" })
                    ], -1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "skel-contact" }, [
                        _createElementVNode("div", { class: "skel skel-av" }),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", { class: "skel skel-md" }),
                          _createElementVNode("div", {
                            class: "skel skel-sm",
                            style: {"margin-top":"4px"}
                          })
                        ])
                      ])
                    ], -1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "skel skel-md" })
                    ], -1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "skel skel-sm" })
                    ], -1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "skel skel-pill" })
                    ], -1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "skel skel-sm" })
                    ], -1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "skel skel-sm" })
                    ], -1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "skel skel-md" })
                    ], -1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", { class: "skel skel-sm" })
                    ], -1),
                    _createElementVNode("td", null, null, -1)
                  ]))]))
                }), 128))
              : (!pageConvs.value.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [...(_cache[26] || (_cache[26] = [
                    _createElementVNode("td", { colspan: "10" }, [
                      _createElementVNode("div", { class: "empty" }, [
                        _createElementVNode("svg", {
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "1.5"
                        }, [
                          _createElementVNode("circle", {
                            cx: "11",
                            cy: "11",
                            r: "8"
                          }),
                          _createElementVNode("line", {
                            x1: "21",
                            y1: "21",
                            x2: "16.65",
                            y2: "16.65"
                          })
                        ]),
                        _createElementVNode("p", null, "Nenhuma conversa encontrada")
                      ])
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageConvs.value, (c, __, ___, _cached) => {
              const _memo = ([c.status, c.assignee?.id ?? null, c.team?.id ?? null, c.waiting_since, c.snoozed_until, c.labels.join(','), c.fluxo_id, props.changedIds?.has(c.id) ?? false])
              if (_cached && _cached.el && _cached.key === c.id && _isMemoSame(_cached, _memo)) return _cached
              const _item = (_openBlock(), _createElementBlock("tr", {
                key: c.id,
                class: _normalizeClass({ 'row-changed': props.changedIds?.has(c.id) })
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(conversationProtocol)(c)), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: "av",
                      style: _normalizeStyle([{"width":"28px","height":"28px","font-size":"10px","overflow":"hidden"}, { background: _unref(avatarColor)(c.contact.name) }]),
                      onMouseenter: ($event: any) => (showContactPopup(c, $event)),
                      onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('hidePopup')))
                    }, [
                      (c.contact.thumbnail)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: c.contact.thumbnail,
                            alt: c.contact.name,
                            style: {"width":"100%","height":"100%","object-fit":"cover","border-radius":"50%","display":"block"},
                            onError: _cache[7] || (_cache[7] = (e) => (e.target as HTMLImageElement).style.display='none')
                          }, null, 40, _hoisted_16))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_unref(initials)(c.contact.name)), 1)
                          ], 64))
                    ], 44, _hoisted_15),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(c.contact.name), 1),
                      (c.contact.phone)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _cache[27] || (_cache[27] = _createElementVNode("svg", {
                              width: "9",
                              height: "9",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13 19.79 19.79 0 0 1 1.61 4.44 2 2 0 0 1 3.59 2.24h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.29 6.29l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(_unref(fmtPhone)(c.contact.phone)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (c.cnpj)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _cache[28] || (_cache[28] = _createElementVNode("svg", {
                              width: "9",
                              height: "9",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("rect", {
                                x: "2",
                                y: "5",
                                width: "20",
                                height: "14",
                                rx: "2"
                              }),
                              _createElementVNode("line", {
                                x1: "2",
                                y1: "10",
                                x2: "22",
                                y2: "10"
                              }),
                              _createElementVNode("line", {
                                x1: "6",
                                y1: "15",
                                x2: "10",
                                y2: "15"
                              })
                            ], -1)),
                            _createTextVNode(" CNPJ " + _toDisplayString(_unref(fmtDoc)(c.cnpj)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (c.cpf)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _cache[29] || (_cache[29] = _createElementVNode("svg", {
                              width: "9",
                              height: "9",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("rect", {
                                x: "2",
                                y: "5",
                                width: "20",
                                height: "14",
                                rx: "2"
                              }),
                              _createElementVNode("line", {
                                x1: "2",
                                y1: "10",
                                x2: "22",
                                y2: "10"
                              }),
                              _createElementVNode("line", {
                                x1: "6",
                                y1: "15",
                                x2: "10",
                                y2: "15"
                              })
                            ], -1)),
                            _createTextVNode(" CPF " + _toDisplayString(_unref(fmtDoc)(c.cpf)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  (c.assignee)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        (c.assignee.thumbnail)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: c.assignee.thumbnail,
                              alt: c.assignee.name,
                              class: "av-img",
                              style: {"width":"26px","height":"26px","cursor":"pointer"},
                              onMouseenter: ($event: any) => (showAssigneePopup(c, $event)),
                              onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('hidePopup')))
                            }, null, 40, _hoisted_22))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "av",
                              style: _normalizeStyle([{"width":"26px","height":"26px","font-size":"10px"}, { background: _unref(avatarColor)(c.assignee.name) }]),
                              onMouseenter: ($event: any) => (showAssigneePopup(c, $event)),
                              onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('hidePopup')))
                            }, _toDisplayString(_unref(initials)(c.assignee.name)), 45, _hoisted_23)),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(c.assignee.name), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, "— sem agente —"))
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(c.team?.name || '—'), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["status-pill", c.status])
                  }, [
                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "sdot" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(statusLabel(c.status)), 1)
                  ], 2)
                ]),
                _createElementVNode("td", null, [
                  (durOf(c).label !== '—')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["dur-cell", durOf(c).type])
                      }, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_27, [
                          (durOf(c).type === 'resolved')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[31] || (_cache[31] = _createElementVNode("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }, null, -1)),
                                _cache[32] || (_cache[32] = _createElementVNode("polyline", { points: "22 4 12 14.01 9 11.01" }, null, -1))
                              ], 64))
                            : (durOf(c).type === 'long')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _cache[33] || (_cache[33] = _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }, null, -1)),
                                  _cache[34] || (_cache[34] = _createElementVNode("line", {
                                    x1: "12",
                                    y1: "9",
                                    x2: "12",
                                    y2: "13"
                                  }, null, -1))
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _cache[35] || (_cache[35] = _createElementVNode("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "10"
                                  }, null, -1)),
                                  _cache[36] || (_cache[36] = _createElementVNode("polyline", { points: "12 6 12 12 16 14" }, null, -1))
                                ], 64))
                        ])),
                        _createTextVNode(" " + _toDisplayString(durOf(c).label), 1)
                      ], 2))
                    : (_openBlock(), _createElementBlock("span", _hoisted_28, "—"))
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["wait-cell", waitOf(c).cls])
                  }, _toDisplayString(waitOf(c).label), 3)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_29, [
                    (c.labels.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(c.labels, (l) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: l,
                            class: "label-chip"
                          }, _toDisplayString(l.replace(/_/g, ' ')), 1))
                        }), 128))
                      : (_openBlock(), _createElementBlock("span", _hoisted_30, "—"))
                  ])
                ]),
                _createElementVNode("td", null, [
                  (c.fluxo_id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_unref(fluxoLabel)(c.fluxo_id)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_32, "—"))
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("button", {
                      class: "open-chat-btn",
                      title: "Abrir chat",
                      onClick: ($event: any) => (emit('openChat', c))
                    }, [...(_cache[37] || (_cache[37] = [
                      _createElementVNode("svg", {
                        width: "13",
                        height: "13",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                      ], -1)
                    ]))], 8, _hoisted_34),
                    _createElementVNode("button", {
                      class: "open-chat-btn",
                      title: "Histórico do contato",
                      onClick: ($event: any) => (emit('openHistory', c))
                    }, [...(_cache[38] || (_cache[38] = [
                      _createElementVNode("svg", {
                        width: "13",
                        height: "13",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("circle", {
                          cx: "12",
                          cy: "12",
                          r: "10"
                        }),
                        _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
                      ], -1)
                    ]))], 8, _hoisted_35)
                  ])
                ])
              ], 2))
              _item.memo = _memo
              return _item
            }, _cache, 11), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("span", _hoisted_38, _toDisplayString(filtered.value.length === 0 ? 'Nenhum resultado' : `${pageStart.value + 1}–${pageEnd.value} de ${filtered.value.length}`), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((pageSize).value = $event)),
              class: "pag-size"
            }, [...(_cache[40] || (_cache[40] = [
              _createElementVNode("option", { value: 10 }, "10 / pág", -1),
              _createElementVNode("option", { value: 25 }, "25 / pág", -1),
              _createElementVNode("option", { value: 50 }, "50 / pág", -1),
              _createElementVNode("option", { value: 100 }, "100 / pág", -1)
            ]))], 512), [
              [
                _vModelSelect,
                pageSize.value,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("button", {
              class: "pag-btn",
              disabled: currentPage.value === 1,
              onClick: _cache[14] || (_cache[14] = ($event: any) => (goPage(currentPage.value - 1)))
            }, [...(_cache[41] || (_cache[41] = [
              _createElementVNode("svg", {
                width: "13",
                height: "13",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
              ], -1)
            ]))], 8, _hoisted_40),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageButtons.value, (p) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: p }, [
                (p === '…')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, "…"))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: _normalizeClass(["pag-btn", { active: p === currentPage.value }]),
                      onClick: ($event: any) => (goPage(Number(p)))
                    }, _toDisplayString(p), 11, _hoisted_42))
              ], 64))
            }), 128)),
            _createElementVNode("button", {
              class: "pag-btn",
              disabled: currentPage.value === totalPages.value,
              onClick: _cache[15] || (_cache[15] = ($event: any) => (goPage(currentPage.value + 1)))
            }, [...(_cache[42] || (_cache[42] = [
              _createElementVNode("svg", {
                width: "13",
                height: "13",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("polyline", { points: "9 18 15 12 9 6" })
              ], -1)
            ]))], 8, _hoisted_43)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})